<mat-dialog-content>
  <div class="d-flex justify-content-center align-items-center w-100 flex-column mt-3 mb-3">
    <app-qr-code (closed)="close()" [isClosable]="true" [isCopyable]="false" [join_address]="link"></app-qr-code>
  </div>
</mat-dialog-content>
